export const addSmartBannerIos = () => {
    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = 'app-id=1627690284';

    document.getElementsByTagName('head')[0].appendChild(meta);
};
